import watchAndPersistResearchState from './watchAndPersistResearchState'
import watchAndPerformQueries from './watchAndPerformQueries'
import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {fork, take} from 'redux-saga/effects'
import {eventChannel, Channel} from 'redux-saga'
import {IStateTreeNode, onSnapshot} from 'mobx-state-tree'
import watchAndRevertResearchStateIfFrozen from './watchAndRevertResearchStateIfFrozen'

export default function* comparableSalesRootSaga(): Generator {
  yield fork(keepThingsGoing)
}

// function channelOfPatches(stateTree: IStateTreeNode): Channel<any> {
//   return eventChannel(emitToChannel => {
//     const listener = (patch: IJsonPatch) => {
//       emitToChannel(patch)
//     }

//     const stopListeningToActions = onPatch(stateTree, listener)

//     return stopListeningToActions
//   })
// }

export function channelOfSnapshots(stateTree: IStateTreeNode): Channel<any> {
  return eventChannel(emitToChannel => {
    const listener = (snapshot: any) => {
      emitToChannel(snapshot)
    }

    const stopListeningToActions = onSnapshot(stateTree, listener)

    return stopListeningToActions
  })
}

function* keepThingsGoing(): Generator {
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const theChannel = yield channelOfSnapshots(mstStore.researchStates)

  const currentStateHandlersByHousingCorporationId: any = {}

  while (true) {
    const snapshot = (yield take(theChannel)) as $FixMe
    for (const hcid in snapshot.byHousingCorporationId) {
      if (!currentStateHandlersByHousingCorporationId[hcid]) {
        currentStateHandlersByHousingCorporationId[hcid] = yield fork(
          handleResearchState,
          hcid,
        )
      }
    }
  }
}

function* handleResearchState(hcid: string): Generator {
  yield fork(watchAndPerformQueries, hcid)
  yield fork(watchAndPersistResearchState, hcid)
  yield fork(watchAndRevertResearchStateIfFrozen, hcid)
}



// WEBPACK FOOTER //
// ./src/comparableSales/sagas/sagas.tsx